import Modal from "../../common/atoms/modal";
import React from "react";
import Dialog from "../../common/atoms/dialog";
import "../../../public/images/content-inactive.svg"
import Utility from "../../utility";
import subscriptionPlans from "../../services/subscriptionPlans";

const ConfirmRejectSubscriptionModal = ({isVisible, setVisible, selectedUser}) => {
    const onConfirmSubscription = async (e) => {
        let [err, subscriptionPlanList] = await Utility.parseResponse(subscriptionPlans.updateSubscription({
            _id: selectedUser._id,
            userId: selectedUser.user._id,
            planId: selectedUser.plan._id,
            status: 'CONFIRM'
        }));
        if (!subscriptionPlanList || err)
            return Utility.apiFailureToast("Unable to get subscriptions");
        onModalClose();
    }

    const onRejectSubscription = async (e) => {
        let [err, subscriptionPlanList] = await Utility.parseResponse(subscriptionPlans.updateSubscription({
            _id: selectedUser._id,
            userId: selectedUser.user._id,
            planId: selectedUser.plan._id,
            status: 'REJECT'
        }));
        if (!subscriptionPlanList || err)
            return Utility.apiFailureToast("Unable to get subscriptions");
        onModalClose();
    }

    const onModalClose = () => {
        setVisible(false)
    }

    return <Modal isVisible={isVisible} onClose={onModalClose}>
        <Dialog
            icon="/images/content-inactive.svg"
            title={`Subscription Request`}
            description={`${selectedUser?.user?.name} has requested for the subscription plan ${
                selectedUser?.plan?.name} worth  ${selectedUser?.plan?.price}`}
            isLoading={false}
            primaryButtonText="Confirm"
            onPrimaryButtonClicked={onConfirmSubscription}
            isSecondaryButton={true}
            secondaryButtonText="Reject"
            onSecondaryButtonClicked={onRejectSubscription}
        />
    </Modal>
}
export default ConfirmRejectSubscriptionModal
